import { Component, OnInit } from '@angular/core';
import { ReimbursementService } from '../reimbursement.service';
import { Router } from '@angular/router';
import { FlashService } from '../../flash/flash.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ListDepartments } from '../reimbursement.interfaces';
import { INgxMyDpOptions } from 'ngx-mydatepicker';
import { FormBuilder, FormGroup, ValidatorFn, ValidationErrors, Validators, FormControl } from '@angular/forms';

@Component({
  selector: 'app-reimbursement-manager-list',
  templateUrl: './reimbursement-manager-list.component.html',
  styleUrls: ['./reimbursement-manager-list.component.css']
})
export class ReimbursementManagerListComponent implements OnInit {
  currentPageNo = 1;
  user;
  entireTeamDetails;
  total;
  perpage;
  rejected;
  itemLenth;
  noData = false;
  reimbursement_manager;
  accepted;
  filterDate;
  status: ListDepartments[];
  myOptions: INgxMyDpOptions = {
    dateFormat: 'yyyy-mm-dd'
  };
  from_Date;
  to_Date;
  emp_Id;
  status_Id = "";
  dateForm: FormGroup;
  constructor(private reimbur: ReimbursementService,
    public router: Router, private flashService: FlashService,
    private spinnerService: Ng4LoadingSpinnerService, private formBuilder: FormBuilder,
  ) {
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.user.roles.forEach(roles => {
      if (roles == 'reimbursement_manager') {
        this.reimbursement_manager = roles;
      }
    });

    this.reimbur.getListStatus().subscribe(status => {
      status.filter(status => {
        if (status.key === "paid") {
          this.accepted = status.key;
        }
      });
    });
  }

  managerAccept(id, teamDetails) {
    let final = {
      items: []
    }
    teamDetails.items.forEach(itemsData => {
      const itemsPayload = {
        _id: itemsData._id,
        approval_cost: itemsData.cost
      }
      final.items.push(itemsPayload);
    });
    this.spinnerService.show();
    this.reimbur.getAccept(final, id, this.accepted).subscribe(accepted => {
      this.spinnerService.hide();
      if (accepted['message']) {
        this.getManagerList();
        this.flashService.show(accepted['message'], 'alert-success');
      }
    }, error => {
      this.spinnerService.hide();
    });
  }

  ngOnInit() {
    this.reimbur.approval = false;
    this.reimbur.rejectApprovalCost = false;
    this.reimbur.getListStatus().subscribe(data => {
      this.status = data;
    });
    this.dateForm = this.formBuilder.group({
      'from_date': ['', Validators.required],
      'to_date': ['', Validators.required]
    }, { validator: this.checkDates('from_date', 'to_date') });

    this.getManagerList();
  }

  public checkDates(startKey: string,
    endKey: string): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const startDate = group.controls[startKey];
      const endDate = group.controls[endKey];
      if (startDate.value !== '' && endDate.value !== '') {
        startDate.setErrors(null);
        endDate.setErrors(null);
        const d_startDate = new Date(startDate.value.formatted);
        const d_endDate = new Date(endDate.value.formatted);
        let startValid = true;
        let endValid = true;
        const d_currentDate = new Date();
        if (startDate.value !== '') {
          if (d_startDate > d_currentDate) {
            startDate.setErrors({ 'type': 'startDateLess', 'message': 'Start Date should be less than Current Date.' });
            startValid = false;
          }
        }
        if (endDate.value !== '') {
          if (d_endDate > d_currentDate) {
            endDate.setErrors({ 'type': 'endtDateLess', 'message': 'End Date should be less than Current Date.' });
            endValid = false;
          }
        }
        if (startDate.value !== '' && endDate.value !== '' && startValid && endValid) {
          if (d_startDate > d_endDate) {
            startDate.setErrors({ 'type': 'startDateLess', 'message': 'Start Date should be less than End Date.' });
            endDate.setErrors({ 'type': 'startDateLess', 'message': 'End Date should be greater than Start Date.' });
          }
        }
      }
      return;
    };
  }

  trackByFn(index) {
    return index;
  }
  getManagerList(pgNo?) {
    if (pgNo != null) {
      this.currentPageNo = pgNo;
    }
    this.filterDate = '';
    if (this.dateForm.valid && this.dateForm.controls.from_date.value && this.dateForm.controls.to_date.value) {
      this.filterDate = `&from_date=${this.dateToString(this.dateForm.controls.from_date.value)}&to_date=${this.dateToString(this.dateForm.controls.to_date.value)}`
    }
    this.spinnerService.show();
    this.reimbur.getManagerList(this.currentPageNo, this.filterDate, this.emp_Id, this.status_Id).subscribe(data => {
      this.spinnerService.hide();
      this.total = data.totalcount;
      this.perpage = data.perpage;
      this.entireTeamDetails = data['reimbursement'];
      if (data['reimbursement'].length === 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
    }, error => {
      this.spinnerService.hide();
    });
  }

  dateToString(value) {
    if (value && value != undefined) {
      const dateString = value.date.year + '-' +
        (value.date.month < 9 ? '0' : '') + value.date.month + '-' +
        (value.date.day < 10 ? '0' : '') + value.date.day;
      return dateString;
    }
  }

  approvedCost(id, userList) {
    this.reimbur.reimbursementUserList = userList;
    this.reimbur.approval = true;
    this.reimbur.rejectApprovalCost = true;
    this.router.navigate(['/reimbursement/manager/view', id]);
  }
  reject(id, userList) {
    this.reimbur.reimbursementUserList = userList;
    this.reimbur.approval = false;
    this.reimbur.rejectApprovalCost = false;
    this.router.navigate(['/reimbursement/manager/view', id]);
  }

  viewItemsDetail(id, userList) {
    this.reimbur.reimbursementUserList = userList;
    this.router.navigate(['/reimbursement/manager/items/view', id]);
  }

  fileDownload(reimbur_id) {
    this.spinnerService.show();
    this.reimbur.getReportFile(reimbur_id).subscribe((blob: Blob) => {
      this.spinnerService.hide();
      const fileName = "report.pdf";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
      }
      else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    }, error => {
      this.spinnerService.hide();
    });
  }

}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/reimbursement/reimbursement-manager-list/reimbursement-manager-list.component.ts